import React, { useRef } from "react";
import QRCode from "react-qr-code";
import { DataAPi } from "../variable/dataVariable";
import { useReactToPrint } from "react-to-print";

const PDFfile = ({dataSet}) => {
    const pdfRef = useRef();


    const printPDF = useReactToPrint({
        content: () => pdfRef.current,
        documentTitle: "Daftar Aset YPIBSK",
    });
/*
    const downloadPDF = () => {
        const input = pdfRef.current;
        html2canvas(input).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('l', 'mm', 'a4', true);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();
            const imgWidth = canvas.width;
            const imgHeight = canvas.height;
            const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
            const imgX = (pdfWidth - imgWidth * ratio) / 2;
            const imgY = 30;
            pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
            pdf.save('Rekapitulasi.pdf');
        });
    }
    */
    const total = [];

    return(
        <>
        <div className="container-fluid justify-content-center" style={{width: "1800px"}}>
            <div className="container bg-success-subtle my-4">
                <div className="row">
                <div className="col-md-10 py-3">
                    CETAK NOMOR INVENTARIS BARANG
                </div>
                <div className="col-md-2 py-3">
                    <button className="btn btn-success" onClick={printPDF}>Cetak QR Aset</button>
                </div>
                </div>
            </div>
            <div ref={pdfRef} className="table-responsive-sm bg-white text-center" style={{ width: "1800px" }}>
                <div className="row g-0">
                        {
                            dataSet.map((aset, index) => {
                                total.push(aset.hargaSatuan)
                                    return (
                                        <div className="col-md-3 text-center" >
                                            <table className="border border-black text-center m-2" style={{ width: "435px"}}>
                                                <tr key={index} style={{height: "90px"}}>
                                                    <th style={{width: "90px"}}>
                                                        <QRCode
                                                            size={256}
                                                            style={{ height: "100%", maxWidth: "100%", width: "100%" }}
                                                            value={DataAPi.urlQrcode + aset.id}
                                                            viewBox={`0 0 256 256`}/>
                                                    </th>
                                                    <th style={{width: "300px"}}>
                                                        <h5 className="border-bottom border-secondary">{aset.namaBarang}</h5>
                                                        <p className="fs-6 fst-normal">{aset.id + aset.nomorInventaris}</p>
                                                    </th>
                                                </tr>
                                                
                                            </table>
                                        </div>
                                    )
                            })
                        }
                </div>            
            </div>
        </div>
        </>
    )
};
export default PDFfile;